/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable, Injector, Compiler, Inject, Type, ViewContainerRef, NgModuleRef, ɵNgModuleType } from '@angular/core';

import { LAZY_LOADER_TOKEN } from './lazy-loader.token';

@Injectable({
  providedIn: 'root'
})
export class LazyLoaderService {
  constructor(
    private readonly _injector: Injector,
    private readonly _compiler: Compiler,
    @Inject(LAZY_LOADER_TOKEN) private readonly _lazyModules: { [key: string]: () => Promise<Type<any>> }
  ) {}

  async load(name: string, container?: ViewContainerRef): Promise<NgModuleRef<any>> {
    const tempModule = await this._lazyModules[name]();

    const moduleFactory = await this._compiler.compileModuleAsync(tempModule);

    const moduleRef = moduleFactory.create(this._injector);

    if (container) {
      let entryComponent;
      const bootstrap = (moduleFactory.moduleType as ɵNgModuleType).ɵmod.bootstrap;
      if (typeof bootstrap === 'function') {
        entryComponent = bootstrap()[0];
      } else {
        entryComponent = bootstrap[0];
      }

      const compRef = container.createComponent(entryComponent);

      compRef.changeDetectorRef.markForCheck();
      return moduleRef;
    }

    return moduleRef;
  }
}
